export default __webpack_public_path__ + "static/media/Square.3cfdd340abcaece32981c7e0ca3322f0.svg";